import { useContext, useState, createContext } from "react";
import axiosx from "../axios/index";

import { useQuery } from "react-query";

const DropdownContext = createContext();

const DropdownContextProvider = ({ children }) => {
  const [citysContext, setCitys] = useState([]);
  const [accountTypeContext, setAccountType] = useState([]);
  const [technicalContext, setTechnical] = useState([]);
  const [deviceTypeContext, setDeviceType] = useState([]);
  const [complaintValidityContext, setComplaintValidity] = useState([]);
  const [agentNameContext, setAgentName] = useState("");

  const saveAgentName = (agentName) => {
    setAgentName(agentName);
    localStorage.setItem("agentName", agentName);
  };

  const getCitys = async () => {
    try {
      const response = await axiosx.get("/dropdown/city");
      if (response.data.success === true) {
        let x = response.data.data;
        x.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });

        return x;
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAccountType = async () => {
    try {
      const response = await axiosx.get("/dropdown/accountType");
      if (response.data.success === true) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getTechnical = async () => {
    try {
      const response = await axiosx.get("/dropdown/technical");
      if (response.data.success === true) {
        let x = response.data.data;
        x.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
        return x;
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDeviceType = async () => {
    try {
      const response = await axiosx.get("/dropdown/deviceType");
      if (response.data.success === true) {
        let x = response.data.data;
        x.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
        return x;
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getComplaintValidity = async () => {
    try {
      const response = await axiosx.get("/dropdown/complaintValidity");
      if (response.data.success === true) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  };

  const {
    data: cityQuery,
    status,
    isPreviousData,
  } = useQuery("citysContext", getCitys, {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 60 * 2,
    staleTime: 1000 * 60 * 60 * 1,
  });

  const {
    data: dataAccountType,
    status: statusAccountType,
    isPreviousData: isPreviousDataAccountType,
  } = useQuery("accountTypeContext", getAccountType, {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 60 * 2,
    staleTime: 1000 * 60 * 60 * 1,
  });

  const {
    data: dataTechnical,
    status: statusTechnical,
    isPreviousData: isPreviousDataTechnical,
  } = useQuery("technicalContext", getTechnical, {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 60 * 2,
    staleTime: 1000 * 60 * 60 * 1,
  });

  const {
    data: dataDeviceType,
    status: statusDeviceType,
    isPreviousData: isPreviousDataDeviceType,
  } = useQuery("deviceTypeContext", getDeviceType, {
    keepPreviousData: true,
  });

  const {
    data: dataComplaintValidity,
    status: statusComplaintValidity,
    isPreviousData: isPreviousDataComplaintValidity,
  } = useQuery("complaintValidityContext", getComplaintValidity, {
    keepPreviousData: true,
  });

  const value = {
    citysContext: cityQuery,
    getCitys,
    accountTypeContext: dataAccountType,
    getAccountType,
    technicalContext: dataTechnical,
    getTechnical,
    deviceTypeContext: dataDeviceType,
    getDeviceType,
    complaintValidityContext: dataComplaintValidity,
    getComplaintValidity,
    agentNameContext,
    setAgentName,
    saveAgentName,
  };

  return (
    <DropdownContext.Provider value={value}>
      {children}
    </DropdownContext.Provider>
  );
};

const useDropdown = () => {
  const context = useContext(DropdownContext);
  return context;
};

export { DropdownContextProvider, useDropdown };
